<script setup>
  import { computed } from 'vue'

  import { useRoute } from 'vue-router'

  const route = useRoute()

  // Computed to check if it's on the pricing route
  const isPricingPage = computed(() => {
    return route?.path?.includes('/pricing') ?? false
  })

  // Props for slot configuration
  defineProps({
    // Visibility control for each section
    showLeftSection: {
      type: Boolean,
      default: true
    },
    showCenterSection: {
      type: Boolean,
      default: true
    },
    showRightSection: {
      type: Boolean,
      default: true
    }
  })
</script>

<template>
  <div v-if="isPricingPage" class="publinker-contextual-header">
    <div class="contextual-content">
      <!-- Left Section -->
      <div v-if="showLeftSection" class="contextual-section left-section">
        <slot name="left"> </slot>
      </div>

      <!-- Central Section -->
      <div v-if="showCenterSection" class="contextual-section center-section">
        <slot name="center">
          <slot name="calendar"> </slot>
        </slot>
      </div>

      <!-- Right Section -->
      <div v-if="showRightSection" class="contextual-section right-section">
        <slot name="right"> </slot>
      </div>

      <!-- Standard slot for compatibility -->
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
  .publinker-contextual-header {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 6px;
    background-color: transparent;
    padding: 1.5rem;
    border-radius: 0 0 12px 12px;
    z-index: 1040;
    min-width: 420px;
    max-width: 90%;
    width: auto;
    height: 3.25rem;
    display: flex;
    align-items: center;
    border: none;
    font-size: 0.95rem;
    margin: 0;
    backface-visibility: hidden;
    transform-style: preserve-3d;
    will-change: transform;

    .contextual-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1.5rem;
      width: 100%;
      height: 100%;
    }

    .contextual-section {
      display: flex;
      align-items: center;
      gap: 0.75rem;

      &.left-section {
        justify-content: flex-start;
      }

      &.center-section {
        justify-content: center;
        flex: 1;
        position: relative;
      }

      &.right-section {
        justify-content: flex-end;
      }
    }

    // Responsiveness
    @media (max-width: 768px) {
      min-width: 300px;
      padding: 0.375rem 1rem;
      height: auto;

      .contextual-content {
        flex-direction: column;
        gap: 0.625rem;
        padding: 0.25rem 0;
      }

      .contextual-section {
        width: 100%;
        justify-content: center;

        &.left-section,
        &.right-section {
          justify-content: center;
        }
      }
    }
  }

  .publinker-contextual-header * {
    z-index: auto !important;
  }

  // Support for OneUI dark theme
  .dark-mode .publinker-contextual-header {
    background-color: transparent;
    color: #e4e6e7;
    border: none;

    .contextual-section {
      &.left-section {
        .btn {
          &:hover {
            box-shadow: 0 4px 12px rgba(122, 38, 193, 0.25);
          }
        }
      }
    }
  }
</style>
